import * as React from "react";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";
import { SubscriptionEnum } from "../../generated/UserAPIAgent";
import PriceDifference from "../../components/Messages/PriceDifference";

const FreeMemberPaymentInfo = (): JSX.Element => {
    return (
        <MainLayout>
            <Headline>決済情報</Headline>
            <section className="confirm-payment">
                <div className="current-payment-method">
                    登録済みの決済方法 : まだ決済情報が登録されていません
                </div>
            </section>
            {
                <PriceDifference
                    subscription={SubscriptionEnum.STANDARD}
                    isNotPaidMember={true}
                    addText={false}
                />
            }
            <LinkButton to={URL_PATHS.paymentPlan()} lines={2} color="primary">
                有料会員プランに登録する
            </LinkButton>
        </MainLayout>
    );
};

export default FreeMemberPaymentInfo;
